<div id="handoversExtraHireChart"></div>
